const secrets = {
    third_party_token_set: {
        token_not_found: '找不到 token 記錄。',
        access_token_expired: '訪問令牌已過期。請重新連接你的賬戶。',
    },
};
export default Object.freeze(secrets);
